import apiClient from './client';

export const investorsApi = {
  getInvestors: async (params = {}) => {
    const response = await apiClient.get('/api/v1/investors', { params });
    return response.data;
  },

  getInvestorsFull: async (params = {}) => {
    const response = await apiClient.get('/api/v1/investors/full', { params });
    return response.data;
  },

  getInvestorDetail: async (pitchbookInvestorId) => {
    const response = await apiClient.get(`/api/v1/investors/${pitchbookInvestorId}`);
    return response.data;
  },
};
